import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/identity/auth`;


export const authService = {
    impersonateUser: async function (username: string) {

        const body = {
            username
        };

        return axios.post(`${GATEWAY_URL}/impersonate-user`, body)
            .then((response) => {
                const auth = response.data.data;
                return auth;
            });

    },
    getUserEvents: async function (params: any) {
        return axios.get(`${GATEWAY_URL}/events`, {
            params
        })
            .then((response) => {
                return response.data;
            });

    },

    
}

export default authService